import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import TextField from '@vimcar/shared-components/components/IForm/components/TextField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewState } from '../Root/viewModel'
import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomContactInformation')

type Props = {
  state: ViewState
  viewModel: ViewModel
}

const CustomContactInformation = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph className={styles.title} variant='subtitle1'>
        {state.currentNode.text}
      </Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      <div className={styles.formContainer}>
        {/* @ts-expect-error@2322 */}
        <IForm
          className={styles.form}
          data={viewModel.data}
          onChange={viewModel.handleFormChange}
          onValid={viewModel.handleFormValid}
        >
          {/* @ts-expect-error@2322 */}
          <TextField label={tp('company')} optional property='company' />
          {/* @ts-expect-error@2322 */}
          <TextField label={tp('name')} property='name' required />
          <TextField
            label={tp('email')}
            property='requestEmail'
            required
            // @ts-expect-error@2322
            validators={viewModel.emailValidator}
          />
          <TextField
            label={tp('phone')}
            property='telephone'
            required
            // @ts-expect-error@2322
            validators={viewModel.phoneValidator}
          />
        </IForm>
      </div>
    </StepContent>
    <BottomActions
      // @ts-expect-error@2322
      customCaptions={{ next: tp('send') }}
      loading={viewModel.loading}
      nextEnabled={viewModel.isValid}
      onNext={viewModel.handleSend}
      showBack
    />
  </React.Fragment>
)

const component = linkViewModel(mkViewModel, CustomContactInformation)
component.displayName = 'CustomContactInformation'
export default component
